import Component from '../Component';
import * as uiStrings from '../../uiStrings';
import Block from './Block';
import childrenLokalityData from './childrenData/lokality';
import childrenNareciData from './childrenData/nareci';
import childrenAdminData from './childrenData/admin';
import SearchButton from '../ControlButtonGroup/SearchButton';

class Layers extends Component {
	constructor(props) {
		super(props);

		this.searchButton = new SearchButton();

		this.nareciBlock = new Block({
			blockClassName: 'js-layers-filterable',
			headingText: uiStrings.DIALECTAL_DIVISION_HEADING,
			controlClassName: 'js-layers-overlay',
		});		

		this.lokalityBlock = new Block({
			blockClassName: 'js-layers-filterable',
			headingText: 'Zdroje',
			controlClassName: 'js-layers-markers',
		});

		this.adminBlock = new Block({
			headingText: uiStrings.ADMINISTRATIVE_DIVISION_HEADING,
			controlClassName: 'js-layers-overlay',
		});

	}

	componentDidMount() {
		this.searchButton.setRefs(this.refs);
		this.searchButton.componentDidMount();

		this.lokalityBlock.setRefs(this.refs);
		this.lokalityBlock.componentDidMount();

		this.nareciBlock.setRefs(this.refs);
		this.nareciBlock.componentDidMount();

		this.adminBlock.setRefs(this.refs);
		this.adminBlock.componentDidMount();
	}

	toggleActive() {
		this.refs['content-layers'].classList.toggle('active');
	}

	render() {
        //bolo class="layerPanel__content--layers active scroll"
		return (`
            <div ref="content-layers" class="layerPanel__content--filters active scroll">
                ${this.searchButton.render()}
				${this.nareciBlock.setChildren(childrenNareciData).render()}
                ${this.lokalityBlock.setChildren(childrenLokalityData).render()}
				${this.adminBlock.setChildren(childrenAdminData).render()}
            </div>`
		);
	}
}

export default Layers;
